import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { FormattedMessage, useIntl } from 'react-intl-next';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { N50, Y500 } from '@atlaskit/theme/colors';
import { PackageIntlProvider } from '../intl-provider';
import messages from './messages';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Error = styled.div({
  height: '100px',
  display: 'flex',
  padding: "var(--ds-space-150, 12px)",
  border: "1px dashed ".concat("var(--ds-border, ".concat(N50, ")")),
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center'
});
var CREATE_ATTACHMENT_PERMISSION_ERROR = 'User does not have permission to create attachments';
export var AttachmentFieldError = function AttachmentFieldError(props) {
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  return /*#__PURE__*/React.createElement(PackageIntlProvider, {
    locale: locale
  }, /*#__PURE__*/React.createElement(Error, {
    "data-testid": "proforma-attachment-field-error"
  }, /*#__PURE__*/React.createElement(WarningIcon, {
    spacing: "spacious",
    color: "var(--ds-icon-warning, ".concat(Y500, ")"),
    label: ""
  }), props.error ? props.error === CREATE_ATTACHMENT_PERMISSION_ERROR ? /*#__PURE__*/React.createElement(FormattedMessage, messages.attachmentPermissionError) : props.error : /*#__PURE__*/React.createElement(FormattedMessage, messages.defaultRenderError)));
};